import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import toast from "react-hot-toast";
import { formatMessage } from "../translations/format-message";
import genderTypeEnum from "./enums/gender-type-enum";

type CustomerCSV = {
  LastName: string | null;
  FirstName: string | null;
  LastNameKana: string | null;
  FirstNameKana: string | null;
  Birthday: string | null;
  Gender: number | null;
  PhoneNumber: string | null;
  Email: string | null;
  PostalCode: string | null;
  Address: string | null;
  CustomerCode: string | null;
  AppMemberShipCode: string | null;
  RefererName: string | null;
  ReasonForVisiting: string | null;
  Notes: string | null;
  DM: boolean;
  Status: number | null;
  BlackList: boolean;
  FirstVisitDate: string | null;
  LastVisitDate: string | null;
  NoOfVisit: number | null;
};
 
// ✅ Helper function to clean CSV fields
const cleanCSVField = (value: string | null | undefined) => {
  if (!value) return "";
  return `"${value.replace(/"/g, '""').replace(/(\r\n|\n|\r)/gm, " ").trim()}"`;
};
 
export function downloadCustomerListCSV(
  isHeadquarter: boolean,
  data: CustomerCSV[],
  filename: string = "customer_list.csv"
) {
  if (!data?.length) {
    toast.error(formatMessage("no_data_error_in_csv"));
    return;
  }
 
  // Headers
  const storeCustomerHeaders = [
    formatMessage("last_name"),
    formatMessage("first_name"),
    formatMessage("last_name_kana"),
    formatMessage("first_name_kana"),
    formatMessage("date_of_birth"),
    formatMessage("gender"),
    formatMessage("contact_number"),
    formatMessage("email"),
    formatMessage("postal_code"),
    formatMessage("address"),
    formatMessage("diana_code"),
    formatMessage("app_membership_code"),
    formatMessage("referer"),
    formatMessage("motivation_to_visit"),
    formatMessage("notes"),
    formatMessage("dm"),
    formatMessage("status"),
    formatMessage("blacklist"),
    formatMessage("first_visit_date"),
    formatMessage("last_visit_date"),
    formatMessage("number_of_visits"),
  ];
 
  const headquarterCustomerHeaders = [
    formatMessage("last_name"),
    formatMessage("first_name"),
    formatMessage("last_name_kana"),
    formatMessage("first_name_kana"),
    formatMessage("date_of_birth"),
    formatMessage("gender"),
    formatMessage("contact_number"),
    formatMessage("email"),
    formatMessage("postal_code"),
    formatMessage("address"),
    formatMessage("diana_code"),
    formatMessage("app_membership_code"),
    formatMessage("notes"),
    formatMessage("dm"),
    formatMessage("status"),
    formatMessage("number_of_visits"),
  ];
 
  // Rows
  const rows = data.map((item) => {
    if (isHeadquarter) {
      return [
        item.LastName || "",
        item.FirstName || "",
        item.LastNameKana || "",
        item.FirstNameKana || "",
        item.Birthday ? moment(item.Birthday).format("YYYY-MM-DD") : "",
        item.Gender !== null ? formatMessage(genderTypeEnum[item.Gender]) : "",
        item.PhoneNumber || "",
        item.Email || "",
        item.PostalCode || "",
        cleanCSVField(item.Address),
        item.CustomerCode || "",
        item.AppMemberShipCode || "",
        cleanCSVField(item.Notes),
        item.DM ? formatMessage("yes") : formatMessage("no"),
        item.Status == 1 ? formatMessage("valid") : formatMessage("invalid"),
        item.NoOfVisit ?? 0,
      ];
    } else {
      return [
        item.LastName || "",
        item.FirstName || "",
        item.LastNameKana || "",
        item.FirstNameKana || "",
        item.Birthday ? moment(item.Birthday).format("YYYY-MM-DD") : "",
        item.Gender !== null ? formatMessage(genderTypeEnum[item.Gender]) : "",
        item.PhoneNumber || "",
        item.Email || "",
        item.PostalCode || "",
        cleanCSVField(item.Address),
        item.CustomerCode || "",
        item.AppMemberShipCode || "",
        item.RefererName || "",
        item.ReasonForVisiting || "",
        cleanCSVField(item.Notes),
        item.DM ? formatMessage("yes") : formatMessage("no"),
        item.Status == 1 ? formatMessage("valid") : formatMessage("invalid"),
        item.BlackList ? formatMessage("yes") : formatMessage("no"),
        item.FirstVisitDate ? moment(item.FirstVisitDate).format("YYYY-MM-DD") : "",
        item.LastVisitDate ? moment(item.LastVisitDate).format("YYYY-MM-DD") : "",
        item.NoOfVisit ?? 0,
      ];
    }
  });
 
  // Compose CSV string (no extra wrapping!)
  const csv = [
    isHeadquarter ? headquarterCustomerHeaders.join(",") : storeCustomerHeaders.join(","),
    ...rows.map((row) => row.join(",")),
  ].join("\r\n");
 
  // Trigger download
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
 
  toast.success(formatMessage("downloaded_started_successfully"));
}